import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomeDashboard from './Screens/HomeDashboard';
import Onboarding from './Screens/Onboarding';
import BridgeBotChat from './Screens/BridgeBotChat';
import QuestDashboard from './Screens/QuestDashboard';
import BiofeedbackSession from './Screens/BiofeedbackSession';
import FoodScan from './Screens/FoodScan';
import SleepSense from './Screens/SleepSense';
import SocialBrowser from './Screens/SocialBrowser';
import FocusBubble from './Screens/FocusBubble';
import PeerDashboard from './Screens/PeerDashboard';
import SplashScreen from './Screens/SplashScreen';
import Introduction from './Screens/Introduction';

function App() {
  // Simple scroll to top function
  React.useEffect(() => {
    const handleRouteChange = () => {
      window.scrollTo(0, 0);
    };
    
    // Call it initially
    handleRouteChange();
  }, []);
  
  return (
    <BrowserRouter>
      <div style={{ animation: 'fadeIn 0.3s ease-in-out' }}>
        <Routes>
          <Route path="/" element={<SplashScreen />} />
          <Route path="/intro" element={<Introduction />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/home" element={<HomeDashboard />} />
          <Route path="/chat" element={<BridgeBotChat />} />
          <Route path="/quest" element={<QuestDashboard />} />
          <Route path="/biofeedback" element={<BiofeedbackSession />} />
          <Route path="/nutrition" element={<FoodScan />} />
          <Route path="/sleep" element={<SleepSense />} />
          <Route path="/social" element={<SocialBrowser />} />
          <Route path="/focus" element={<FocusBubble />} />
          <Route path="/peer" element={<PeerDashboard />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
